import { render } from "./FooterSection.vue?vue&type=template&id=21c275da&scoped=true"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import "./FooterSection.vue?vue&type=style&index=0&id=21c275da&scoped=true&lang=css"

import exportComponent from "/home/aungkhantkoko/Desktop/PortFolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c275da"]])

export default __exports__